/* eslint-disable no-underscore-dangle */
import { ApolloClient, InMemoryCache } from "@apollo/client";

const APOLLO_CLIENT = new ApolloClient({ uri: window._env.REACT_APP_GRAPHQL_API, cache: new InMemoryCache() });

export default APOLLO_CLIENT;
